import logo from '../assets/images/Logo.png';
import { SITE_URL } from '../config/app';


export default function Header() {
    return (
        <header className="top-0 z-50 bg-white border-b border-gray-200">
        <nav className="max-w-screen-2xl flex flex-wrap items-center justify-between mx-auto p-4 2xl:px-0">
            <a href={`${SITE_URL}/`} className="mx-auto md:ml-0">
                <img
                    className="h-12 w-auto"
                    src={logo}
                    alt=""
                />
            </a>
        </nav>
      </header>
    );
}